








































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import LayoutHeader from '@/components/layout/LayoutHeader.vue';
import ValidateReservationCode from '@/components/ValidateReservationCode.vue';
import VerifyReservation from '@/components/VerifyReservation.vue';
import FormTimeoutModal from '@/components/FormTimeoutModal.vue';
import store from '@/store';
import IdleVue from 'idle-vue';

Vue.use(IdleVue, {
	eventEmitter: new Vue(),
	store,
	idleTime: 1020000 // (60000 * 17)
});

@Component({
	components: {
		'form-timeout': FormTimeoutModal,
		'layout-header': LayoutHeader,
		'validate-reservation-code': ValidateReservationCode,
		'verify-reservation': VerifyReservation
	}
})
export default class App extends Vue {
	errorMessage = '';
	tokenValidationRequired = true;
	clearFormFields = false;
	showIdleTimeoutWarningDialogToggle = false;
	isIdleTimeoutActive = true;

	data() {
		return {
			reservationCodeProp: this.$route.query.reservationcode,
		};
	}

	reservationCodeValidated() {
		this.tokenValidationRequired = false;
		this.deactivateIdleTimer();
	}

	deactivateIdleTimer() {
		this.isIdleTimeoutActive = false;
	}

	onIdleWarningQuit() {
		this.clearFormFields = !this.clearFormFields;
		this.tokenValidationRequired = true;
	}

	setIdleTimeoutActive(active: boolean) {
		this.isIdleTimeoutActive = active;
	}

	// hook method for when user goes idle
	onIdle() {
		if (this.isIdleTimeoutActive) {
			this.showIdleTimeoutWarningDialogToggle = !this.showIdleTimeoutWarningDialogToggle;
		}
	}

	// hook method for when user goes active
	onActive() {
		// console.log('User is Active');
	}
}
